import utcToZonedTime from 'date-fns-tz/utcToZonedTime';

/**
 * @deprecated This helper is deprecated. Use the @dealroadshow/uikit-date-time class with appropriate methods instead.
 * @param {string} timeZone - Timezone
 * @param {(number|string|Date)} date - Number value should be in milliseconds!
 * @returns Date
 */
const utcToZonedDate = (
  timeZone: (string | null) = null,
  date: string | number | Date = new Date(),
): Date => utcToZonedTime(date, timeZone);

export default utcToZonedDate;
